import { render } from "./RigaIntervento.vue?vue&type=template&id=b3bef068"
import script from "./RigaIntervento.vue?vue&type=script&lang=js"
export * from "./RigaIntervento.vue?vue&type=script&lang=js"

import "./RigaIntervento.vue?vue&type=style&index=0&id=b3bef068&lang=css"

import exportComponent from "C:\\Ecommerce\\CONAD_MANUTENZIONI\\conad-manutenzioni\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__